<template>
	<div class="w-full">
		<div class="flex space-x-2">
		    <input 
		    	type="text" 
		    	name="tagsinput"
		    	:placeholder="placeholder" 
		    	class="shadow-sm px-2 py-2 border w-full border-gray-300 rounded-md focus:outline-none focus-visible:ring-orange-500 focus:ring-orange-500 focus:border-orange-500"
		    	v-model="phone"
		    	@keyup.enter="addPhone"
    			@focusout="addPhone"
				ref="phoneValidStatus"
		    > 
  		</div>
  		<div 
  			v-if="tags && tags.length > 0"
  			class="flex w-full mt-2 p-2 rounded-md bg-gray-200 items-center"
  		>
  			<div 
  				:key="renderPhone"
  				v-for="(phone,index) in tags"
  				class="bg-white text-black p-2 flex ml-2 rounded-md items-center" 
  			>
  				<span class="text-sm">{{ phone }}</span>
  				<div
  					class="ml-2 text-red-500 cursor-pointer"
  					@click="deletePhone(index)"
  				>
  					<XCircleIcon
	  					class="h-4 w-4" 
						aria-hidden="true" 
						
	  				/>
  				</div>
  				
  			</div>
  		</div>
	</div>
</template>

<script>
import { PlusSmIcon as PlusSmIconSolid } from '@heroicons/vue/solid';
import validateRule from "Resources/config/validate_rule";
import validator from 'validate.js';
import helper from "Resources/util/helper";
import {XCircleIcon,} from '@heroicons/vue/outline'

	export default {
		name: "TagsInput",

		emits: ['selected', 'update:modelValue'],

		props: {
			cssClass: {
				default: "",
				type: String,
				required: false
			},
			modelValue: {
				default: () => [],
				type: Array,
				required: false
			},
			placeholder: {
				default: "",
				type: String,
				required: false
			},
			limit: {
				default: 2,
				type: Number,
				required: false
			},
			validateRule: {
				default: () => ({
					phone: validateRule.rule.phone
				}),
				type: Object,
				required: false
			},
			auto_validate: {
				default: true,
				type: Boolean,
				required: false
			},
		},

		components:{
			XCircleIcon,
			PlusSmIconSolid
		},

		data() {
			return {
				tags: [],
				phone: null,
				renderPhone: 0,
				errorMessage: null,
				validation: null,
			};
		},

		watch: {
			modelValue: {
				handler() {

					this.tags = this.modelValue;
					
					this.refresh();
				}
			},
		},

		mounted() {
			if(this.modelValue && this.modelValue.length > 0){
				this.tags = this.modelValue;
			}
			
		},

		methods: {
			addPhone(){
				if(this.tags.length < this.limit){
					if(this.validate(this.phone) && this.phone){
						this.tags.push(this.phone);
						this.phone = null;
					}
				}
				this.emit();
			},

			deletePhone(key){
				
				delete this.tags[key];

				this.tags = this.tags.filter(item => item);
				
				this.refresh();
			},

			emit(){
				this.$emit("selected", this.tags);
				this.$emit("update:modelValue", this.tags);
			}, 

			reset() {
				this.tags = [];
				this.refresh();
			},

			refresh() {
				this.renderPhone += 1;
				this.emit();
			},

			validate(text) {
				if(!this.auto_validate) {
					return true;
				}

				if (text && text.length > 1) {
					let rule = this.validateRule;

					this.validation = validator({ phone: text }, rule);

					if (this.validation) {
						helper.flashErrorMessage(this.validation.phone[0])
					}

					return !this.validation;
				}
			}
		}
	};
</script>